
import {
  LayoutDashboard,
  MessageSquare,
  Settings,
  Users,
  BrainIcon,
  ImageIcon,
  FileImageIcon,
  AudioLines,
  LucideIcon,
  ListChecks,
  ShieldAlert,
  FileText,
  Video,
  Mic,
  FileCheck,
  Copy,
  UserCheck,
  Key,
  Shield,
  FileSymlink,
} from "lucide-react";
import { Permission } from "@/utils/permissions";

export interface SidebarRouteItem {
  title: string;
  icon: LucideIcon;
  href: string;
  variant?: "default" | "ghost";
  requiredPermission?: Permission;
  allowedRoles?: string[];
}

type Route = {
  label: string;
  icon: LucideIcon;
  path: string;
  roles: string[];
};

const publicRoutes: Route[] = [
  {
    label: "How It Works",
    icon: ListChecks,
    path: "/how-it-works",
    roles: ["guest", "user", "admin"],
  },
  {
    label: "Pricing",
    icon: ShieldAlert,
    path: "/pricing",
    roles: ["guest", "user", "admin"],
  },
];

const userRoutes: Route[] = [
  {
    label: "Dashboard",
    icon: LayoutDashboard,
    path: "/dashboard",
    roles: ["user", "admin"],
  },
  {
    label: "Text Analysis",
    icon: MessageSquare,
    path: "/text-analysis",
    roles: ["user", "admin"],
  },
  {
    label: "Image Analysis",
    icon: ImageIcon,
    path: "/image-analysis",
    roles: ["user", "admin"],
  },
  {
    label: "Document Analysis",
    icon: FileImageIcon,
    path: "/document-analysis",
    roles: ["user", "admin"],
  },
  {
    label: "Audio Analysis",
    icon: AudioLines,
    path: "/audio-analysis",
    roles: ["user", "admin"],
  },
];

export const adminRoutes = [
  {
    label: "User Management",
    path: "/user-management",
    icon: Users,
  },
  {
    label: "Settings",
    path: "/settings",
    icon: Settings,
  },
  {
    label: "ML Training",
    path: "/ml-training",
    icon: BrainIcon,
  },
];

export const routes = [...publicRoutes, ...userRoutes];

// Convert routes to SidebarRouteItems
export const sidebarRoutes: SidebarRouteItem[] = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    href: "/dashboard",
  },
  {
    title: "Text Analysis",
    icon: FileText,
    href: "/text-analysis",
    requiredPermission: "view_analysis",
  },
  {
    title: "Image Analysis",
    icon: ImageIcon,
    href: "/image-analysis",
    requiredPermission: "view_analysis",
  },
  {
    title: "Video Analysis",
    icon: Video,
    href: "/video-analysis",
    requiredPermission: "view_analysis",
  },
  {
    title: "Voice Analysis",
    icon: Mic,
    href: "/voice-analysis",
    requiredPermission: "view_analysis",
  },
  {
    title: "Document Analysis",
    icon: FileCheck,
    href: "/document-analysis",
    requiredPermission: "view_analysis",
  },
  {
    title: "Plagiarism Check",
    icon: Copy,
    href: "/plagiarism-check",
    requiredPermission: "view_analysis",
  },
  {
    title: "Proxy Interview",
    icon: UserCheck,
    href: "/proxy-interview",
    requiredPermission: "view_analysis",
  },
  {
    title: "Documentation",
    icon: FileSymlink,
    href: "/documentation",
    allowedRoles: ["admin", "analyst"],
  },
  {
    title: "API Credentials",
    icon: Key,
    href: "/api-credentials",
    requiredPermission: "manage_api_keys",
  },
  {
    title: "Admin",
    icon: Shield,
    href: "/admin",
    requiredPermission: "access_admin_panel",
  },
];
